import { ChatbotFileDTO } from "./chatbot-file-dto";

/** KeyValuePair int/string del backend (JSON: Key, Value). */
export interface KeyValuePairIntString {
    Key: number;
    Value: string;
}

export class ChatbotDocumentDTO
{
    IdDocument: string;
    IdCategory: number;
    IdChat: string;
    Status: boolean;
    File: ChatbotFileDTO;
    FileIa: ChatbotFileDTO;
    CreationDate: string;
    CreationUser: string;
    LastUpdateDate: string;
    LastUpdateUser: string;
    Title: string;
    Description: string;
    InitDate: Date;
    EndDate: Date;
    UseIa: boolean;
    PositiveFilters: KeyValuePairIntString[] | null;
    NegativeFilters: KeyValuePairIntString[] | null;
    LastReindexedDate: string;
    RedirectUrl: string;
    ReturnDocumentAsReference: boolean;
}

export class ChatbotDocumentFilter
{
    IdChat: string;
    IdCategory?: number;
}

export class ChatbotDocumentUpdateFileDTO
{
    IdClient: string;
    IdProject: string;
    IdChat: string;
    Blobname: string;
    Filename: string;
    Filesize: number;
    ContentType: string;
    ContentHash: string;
}